import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button } from 'antd'
import Dialog from '../Dialog'
import $t from 'i18n'
import { useDispatch } from 'react-redux'
import Actions from 'actions'
import dayjs from 'dayjs'
import loginService from 'services/loginService'
import routes from 'consts/routes'

const ResumeSessionBtn = ({ disabled, loading }) => {
  const dispatch = useDispatch()

  return (
    <Button
      onClick={() => {
        dispatch(Actions.createAction(Actions.TIMEOUT_MODAL_CLOSED))
        dispatch(Actions.createAction(Actions.REFRESH_TOKEN_REQUESTED))
      }}
      className='dialog-action'
      type='primary'
      disabled={disabled}
      loading={loading}
    >
      {$t('dialogs.timeout.resumeSession')}
    </Button>
  )
}

const SaveBtn = ({ disabled }) => {
  const dispatch = useDispatch()
  return (
    <Button
      className='dialog-action'
      onClick={() => {
        dispatch(Actions.createAction(Actions.TIMEOUT_MODAL_CLOSED))
        dispatch(Actions.createAction(Actions.SAVE_PROGRESS_DIALOG_OPENED))
        dispatch(Actions.createAction(Actions.REFRESH_TOKEN_REQUESTED))
      }}
      type='outline'
      disabled={disabled}
    >
      {$t('dialogs.timeout.save')}
    </Button>
  )
}

const ExitBtn = () => {
  const dispatch = useDispatch()
  return (
    <Button
      className='dialog-action'
      onClick={() => {
        dispatch(Actions.createAction(Actions.LOGOUT_REQUESTED))
      }}
      type='outline'
    >
      {$t('dialogs.timeout.exit')}
    </Button>
  )
}

const TimeoutModal = ({ isSavePlanShouldAppear }) => {
  const dispatch = useDispatch()
  const shouldShowModal = useSelector(state => state.app.shouldShowTimeoutModal)
  const isLoggingOut = useSelector(state => state.app.isLoggingOut)
  const accessTokenLifetime = useSelector(
    state => state.app.appConfig?.access_token_lifetime
  )
  const inactivityTimeoutWarning = useSelector(
    state => state.app.appConfig?.inactivity_timeout_warning
  )
  const [remainingSeconds, setRemainingSeconds] = useState()

  useEffect(() => {
    if (!shouldShowModal) {
      return
    }
    setRemainingSeconds(Math.min(accessTokenLifetime, inactivityTimeoutWarning))

    const interval = setInterval(() => {
      setRemainingSeconds(prevSeconds => {
        // Update remaining seconds every second
        if (prevSeconds > 0) {
          return prevSeconds - 1
        } else {
          dispatch(Actions.createAction(Actions.LOGOUT_REQUESTED))
          return 0
        }
      })
    }, 1000)

    return () => clearInterval(interval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowModal])

  const isExpired = !remainingSeconds

  return (
    <Dialog
      isVisible={shouldShowModal}
      className='timeout-dialog'
      closable={false}
      footerActions={[
        <ResumeSessionBtn
          key={'resumeSession'}
          disabled={isExpired}
          loading={isLoggingOut}
        />,
        isSavePlanShouldAppear ? (
          <SaveBtn key={'save'} />
        ) : (
          <ExitBtn key={'exit'} />
        )
      ]}
    >
      <div className='timeout-dialog-content'>
        <div className='timeout-dialog-subtitle subtitle'>
          {isExpired && $t('dialogs.timeout.descriptionExpired')}
          {!isExpired &&
            $t('dialogs.timeout.description', {
              seconds: dayjs(remainingSeconds * 1000).format('mm:ss')
            })}
        </div>
      </div>
    </Dialog>
  )
}

export default TimeoutModal
